import { Tracker } from '@formily/reactive';
import { useForceUpdate } from './useForceUpdate';
import { useCompatFactory } from './useCompatFactory';
export var useObserver = function (view, options) {
    var forceUpdate = useForceUpdate();
    var tracker = useCompatFactory(function () {
        return new Tracker(function () {
            if (typeof (options === null || options === void 0 ? void 0 : options.scheduler) === 'function') {
                options.scheduler(forceUpdate);
            }
            else {
                forceUpdate();
            }
        }, options === null || options === void 0 ? void 0 : options.displayName);
    });
    return tracker.track(view);
};
//# sourceMappingURL=useObserver.js.map